/**
 * Clogo Component
 * Displays the CABAL logo with optional text
 */
'use client';
import { useEffect } from 'react';
import { Ctext } from '../Ctext';
import { Cimage, CIMAGE_OBJECT_FIT } from '../Cimage';
import { FontWeight } from '@/theme/typography';
import { TextPreset } from '@/constants/componentPresets';
import { useSeqLog } from '@/hooks/telemetry/use-seq-log';
export interface ClogoProps {
    size?: number;
    withText?: boolean;
    className?: string;
    priority?: boolean;
}
const CLOGO_COMPONENT_NAME = 'Clogo';
const CLOGO_RENDER_MESSAGE = 'Clogo render';
const CLOGO_IMAGE_SRC = '/logo.png';
const CLOGO_ALT_TEXT = 'CABAL Logo';
const CLOGO_CABAL_TEXT = 'CABAL';
const CLOGO_AI_TEXT = 'AI';
export function Clogo({ size = 48, withText = false, className, priority = true, }: ClogoProps) {
    const seqLog = useSeqLog(CLOGO_COMPONENT_NAME);
    useEffect(() => {
        seqLog(CLOGO_RENDER_MESSAGE, { size, withText, priority });
    }, [size, withText, priority, seqLog]);
    if (!withText) {
        // Just the logo icon
        return <Cimage src={CLOGO_IMAGE_SRC} alt={CLOGO_ALT_TEXT} width={size} height={size} static={true} priority={priority} objectFit={CIMAGE_OBJECT_FIT.Contain} className={className} style={{
                display: 'block',
                translate: '1px -1px',
            }}/>
            ;
    }
    // Logo with text composed using Ctext
    const cabalTextSize = size * 0.5;
    const aiTextSize = size * 0.35; // AI is smaller
    return (<span style={{
            display: 'inline-flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: `${size * 0.25}px`,
        }} className={className}>
            <Cimage src={CLOGO_IMAGE_SRC} alt={CLOGO_ALT_TEXT} width={size} height={size} static={true} priority={priority} objectFit={CIMAGE_OBJECT_FIT.Contain} style={{
            display: 'block',
            translate: '1px -1px',
        }}/>
            <span style={{
            display: 'inline-flex',
            flexDirection: 'row',
            alignItems: 'baseline',
            gap: `${size * 0.1}px`, // Closer spacing between CABAL and AI
        }}>
                <Ctext preset={TextPreset.Accent} size={cabalTextSize} weight={FontWeight.Bold} style={{
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            whiteSpace: 'nowrap',
        }}>
                    {CLOGO_CABAL_TEXT}
                </Ctext>
                <Ctext preset={TextPreset.Regular} size={aiTextSize} weight={FontWeight.Regular} style={{
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            whiteSpace: 'nowrap',
        }}>
                    {CLOGO_AI_TEXT}
                </Ctext>
            </span>
        </span>);
}
